import { render, staticRenderFns } from "./blogDetails.vue?vue&type=template&id=6d404373&scoped=true&"
import script from "./blogDetails.vue?vue&type=script&lang=js&"
export * from "./blogDetails.vue?vue&type=script&lang=js&"
import style0 from "./blogDetails.vue?vue&type=style&index=0&id=6d404373&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d404373",
  null
  
)

export default component.exports